import * as yup from 'yup'

import i18next from '../../../../../../i18n.js'

const BILLING_PROJECTS_MODEL = {
    date: 'date',
    status: 'status',
    taxable: 'amount',
    sal: 'sal_id',
    note: 'description',
}

const DEFAULT_BILLING_PROJECTS_MOCK = {
    [BILLING_PROJECTS_MODEL.date]: null,
    [BILLING_PROJECTS_MODEL.status]: null,
    [BILLING_PROJECTS_MODEL.taxable]: null,
    [BILLING_PROJECTS_MODEL.sal]: null,
    [BILLING_PROJECTS_MODEL.note]: '',
}

const RequestValidationSchema = yup.object().shape({
    [BILLING_PROJECTS_MODEL.date]: yup
        .date()
        .required(i18next.t('validation:general_form.date')),
    [BILLING_PROJECTS_MODEL.status]: yup
        .object()
        .required(i18next.t('validation:general_form.status')),
    [BILLING_PROJECTS_MODEL.sal]: yup.object().nullable(),
    [BILLING_PROJECTS_MODEL.taxable]: yup
        .string()
        .required(i18next.t('validation:general_form.taxable')),
    [BILLING_PROJECTS_MODEL.note]: yup
        .string()
        .required(i18next.t('validation:general_form.note_required')),
})

export {
    BILLING_PROJECTS_MODEL,
    DEFAULT_BILLING_PROJECTS_MOCK,
    RequestValidationSchema as validationSchema,
}
